import { Button } from '@fluentui/react-components';
import { ArrowDownload20Regular } from "@fluentui/react-icons";
import { primaryIcon } from '../../styles/customStyles';

const FileDownloadComponent = (props: any) => {
    const handleDownload = () => {
        const content = props.data;
        const blob = new Blob([content], { type: 'text/plain' });
        // Create a download link
        const downloadLink = document.createElement('a');
        downloadLink.href = URL.createObjectURL(blob);
        downloadLink.download = `${props.fileName}.csv`;
        // Trigger a click on the link to start the download
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
    };
    return (
        <Button shape="circular" appearance="subtle" size="small" onClick={handleDownload} iconPosition='before' icon={<ArrowDownload20Regular {...primaryIcon} />}>
            Export
        </Button>
    )
}

export { FileDownloadComponent }